// import 'bootstrap/dist/css/bootstrap.css';
import '@progress/kendo-theme-default/dist/all.css';
import './OSUWMC/project.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import SkipNavLink from './components/Shared/SkipNav';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
/*baseUrl is set either by %PUBLIC_URL% or homepage field in package.json*/
/*homepage field in package.json is for subfolder when deployed to Development, Staging and Production servers */
/*Set %PUBLIC_URL% as '/' in Visual Studio project debug property for debug in IIS Express localhost*/
ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <SkipNavLink> Skip Navigation </SkipNavLink>
        <App></App>
    </BrowserRouter>,
    rootElement);

